var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarC = function SvgDefaultAvatarC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 55.8c3.1 0 5.1-.8 6.4-1.3.5-.3 1.1-.5 1.4-.5.8 0 .8.5 1.7.5 1.7 0 3.7-4.7 3.7-7.7 0-1.3-.4-2-1.1-2-.9 0-1.3 1.8-2.2 3.3-1.6 2.6-4.6 4-7.9 4-6.7 0-11.3-6.6-11.3-13.5 0-6.4 3.8-11.1 9.7-11.1 3.6 0 7.9 2.3 8.9 5.8.7 2.4 1 3.7 2.1 3.7.8 0 1.6-1.1 1.6-3.8 0-3-1-7-2.7-7-.8 0-1 .5-1.7.5-.4 0-.7-.1-1.4-.5-1.8-.8-4.1-1.6-6.9-1.6-8.3 0-14.9 6.6-14.9 15.7 0 8.9 6.7 15.5 14.6 15.5z"
  })));
};
export default SvgDefaultAvatarC;